import moment from 'moment'

export default {
  raffleValue: (state) => state.raffle.rules.value,
  formattedRaffleDates: (state) => ({
    startDate: moment(state.raffle.start_date).format('DD/MM/YYYY'),
    endDate: moment(state.raffle.end_date).format('DD/MM/YYYY'),
    appExhibitionDate: state.raffle.app_start_exhibition_date
      ? moment(state.raffle.app_start_exhibition_date).format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY'),
  }),
  generateWinner: (state) => state.generateWinner,
}
